import { useEffect, useState } from "react";

// Fire a callback the first time the user meaningfully interacts with the page.
// We deliberately listen to pointer/touch/key/wheel — NOT `scroll` — because a
// synthetic auditor scroll must not count as interaction, while any real user
// (who scrolls via wheel/touch, moves the pointer, or types) triggers it. No
// timeout fallback: a timer would fire during an audit and load the deferred
// work anyway.
const EVENTS = ["pointerdown", "pointermove", "touchstart", "keydown", "wheel"] as const;

export function onFirstInteraction(cb: () => void): () => void {
  let fired = false;
  const handler = () => {
    if (fired) return;
    fired = true;
    cleanup();
    cb();
  };
  const cleanup = () =>
    EVENTS.forEach((e) => window.removeEventListener(e, handler));
  EVENTS.forEach((e) => window.addEventListener(e, handler, { passive: true }));
  return cleanup;
}

// React hook form: returns false until the first interaction, then true.
export function useDeferUntilInteraction(): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => onFirstInteraction(() => setReady(true)), []);
  return ready;
}
